<template>
  <div class="position-relative d-inline-block">
    <div class="d-flex flex-row"  :class="{ 'nowrap': imageMaking }">
      <Tooth v-for="t in teeth.top"
             :key='`top-t-${t.cnt}`'
             :toothNumber="t.cnt"
             :imageMaking="imageMaking"
             :disabled="disabled"
             position="top"
             :mode="mode"/>
    </div>

    <div class="dashed-v"></div>

    <div class="patient-formula-bottom dashed-b d-flex flex-row"
         :class="{ 'nowrap': imageMaking }">
      <Tooth v-for="t in teeth.bottom"
             :key='`top-t-${t.cnt}`'
             :toothNumber="t.cnt"
             :imageMaking="imageMaking"
             :disabled="disabled"
             position="bottom"
             :mode="mode"/>
    </div>
  </div>
</template>

<script>
import Tooth from "@/components/parts/patients/teeth/Tooth"

export default {
  name: "AdultTeeth",
  components: {
    Tooth
  },
  props: {
    mode: {
      type: String,
      default: 'status'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    imageMaking: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      teeth: {
        top: [
          { cnt: 18 },
          { cnt: 17 },
          { cnt: 16 },
          { cnt: 15 },
          { cnt: 14 },
          { cnt: 13 },
          { cnt: 12 },
          { cnt: 11 },
          { cnt: 21 },
          { cnt: 22 },
          { cnt: 23 },
          { cnt: 24 },
          { cnt: 25 },
          { cnt: 26 },
          { cnt: 27 },
          { cnt: 28 },
        ],
        bottom: [
          { cnt: 48 },
          { cnt: 47 },
          { cnt: 46 },
          { cnt: 45 },
          { cnt: 44 },
          { cnt: 43 },
          { cnt: 42 },
          { cnt: 41 },
          { cnt: 31 },
          { cnt: 32 },
          { cnt: 33 },
          { cnt: 34 },
          { cnt: 35 },
          { cnt: 36 },
          { cnt: 37 },
          { cnt: 38 },
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dashed-b {
  border-top: 2px dashed #E8F2FC;
}
.dashed-v {
  border-right: 2px dashed #E8F2FC;
  position: absolute;
  left: 50%;
  top: 0;
  height: 100%;
  margin-left: -1px;
}
</style>
